import { useEffect, useRef, useState } from 'react';

export const useLoadingWithMinTime = (isLoading: boolean, minTime: number = 1000) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const startTimeRef = useRef<number | null>(null);

  useEffect(() => {
    if (isLoading) {
      startTimeRef.current = Date.now();
      setShowSpinner(true);
    } else {
      if (startTimeRef.current === null) {
        setShowSpinner(false);
        return;
      }

      const elapsed = Date.now() - startTimeRef.current;
      const remaining = Math.max(0, minTime - elapsed);

      const timer = setTimeout(() => {
        setShowSpinner(false);
        startTimeRef.current = null;
      }, remaining);

      return () => clearTimeout(timer);
    }
  }, [isLoading, minTime]);

  return showSpinner;
};
